module.exports = __webpack_public_path__ + "static/img/news8.8b9e406.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news8.jpg
// module id = /1UE
// module chunks = 1